import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from 'react';
const DWProvider = React.createContext({});
function DataWrapperProvider({ children }) {
    const [dataWrapper, setDataWrapper] = useState();
    const value = useMemo(() => ({ dataWrapper, setDataWrapper }), [dataWrapper]);
    return (_jsx(DWProvider.Provider, { value: value, children: children }));
}
export const useDataWrapper = () => { var _a; return (_a = useContext(DWProvider)) === null || _a === void 0 ? void 0 : _a.dataWrapper; };
export const useSetDataWrapper = () => { var _a; return (_a = useContext(DWProvider)) === null || _a === void 0 ? void 0 : _a.setDataWrapper; };
export default DataWrapperProvider;
